import React from "react";
import close from "../../assets/images/weekly star image/close.png";
import { useTranslation } from "react-i18next";

const Dialog = ({ isOpen, closeDialog, description }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[999999]">
      <div
        className="w-[90%] md:w-[80%] lg:w-[70%] max-w-2xl rounded-2xl relative shadow-2xl"
        style={{
          background:
            "linear-gradient(135deg, rgba(200, 61, 72, 0.95) 0%, rgba(150, 40, 50, 0.95) 100%)",
          backdropFilter: "blur(10px)",
          border: "2px solid rgba(253, 241, 159, 0.3)",
        }}
      >
        {/* Header Section */}
        <div className="pt-6 pb-4 px-6 border-b border-opacity-30 border-[#FDF19F]">
          <p className="font-rubik font-bold text-center text-[#FDF19F] text-lg md:text-xl">
            {t("Rules")}
          </p>
        </div>

        {/* Content Section */}
        <div className="p-6 md:p-8 max-h-[70vh] overflow-y-auto scrollbar-hidden">
          <p
            className="font-lemon text-[#FFEE40] text-sm md:text-base lg:text-lg font-normal leading-relaxed md:leading-8 text-center whitespace-normal"
            style={{
              textShadow: "1px 1px 3px rgba(0, 0, 0, 0.5)",
              lineHeight: "1.8",
            }}
          >
            {description}
          </p>
        </div>

        {/* Close Button */}
        <button
          onClick={closeDialog}
          className="absolute -top-4 -right-4 z-50 hover:scale-110 transition-transform duration-200 rounded-full p-1"
          style={{
            background: "linear-gradient(135deg, #C83D48 0%, #96282B 100%)",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
          }}
        >
          <img src={close} alt="close" className="w-8 h-8" />
        </button>
      </div>
    </div>
  );
};

export default Dialog;
